var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{attrs:{"action":"https://wechat.caiii.cn/site/poi/web/waterTicket/importData","headers":_vm.headers,"on-change":_vm.onChange,"auto-upload":true,"show-file-list":false,"accept":".xls, .xlsx"}},[_c('el-button',{attrs:{"type":"warning","icon":"el-icon-folder-add"}},[_vm._v("批量导入")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7993b4b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/UpDome.vue
// module id = null
// module chunks = 